import { render, staticRenderFns } from "./Xzqh.vue?vue&type=template&id=47254124&scoped=true&"
import script from "./Xzqh.vue?vue&type=script&lang=js&"
export * from "./Xzqh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47254124",
  null
  
)

export default component.exports